export default "__VITE_ASSET__a4529edc__"